module.exports = __webpack_public_path__ + "media/src/img/ban-3-8accc8d5b4a062d7f0d38ef217ba7394.svg";